import React from "react"
import { ThemeProvider } from "styled-components"
import { themeDefaultV2 as themeDefault } from "@fastly/consistently"
import { Header } from "~components/Header/Header"
import { FooterWrapper as Footer } from "~components/Footer/Footer"
import { ConsistentlyProvider } from "@fastly/consistently-vanilla"
import { themeDocumentation } from "@fastly/consistently-vanilla/tokens"

import "@fastly/consistently-vanilla/assets/css/colors.css"
import "@fastly/consistently-vanilla/assets/css/typography.css"
import "@fastly/consistently-vanilla/assets/css/tokens.css"

import "@fastly/consistently-vanilla/css"

import "~vanilla/global.css"
import "~vanilla/utilities.css"
import "~vanilla/grid-common.css"

const LayoutCore = ({ children }) => {
  return (
    <ConsistentlyProvider theme={themeDocumentation}>
      <ThemeProvider theme={themeDefault}>
        <Header />

        <div className="grid-container">
          {children}

          <Footer />
        </div>
      </ThemeProvider>
    </ConsistentlyProvider>
  )
}

export default LayoutCore
